import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500">
      <div className="container mx-auto max-w-6xl">
        <div className="bg-white border-2 border-slate-200 rounded-2xl shadow-2xl p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 p-3 bg-cyan-50 rounded-xl">
              <Cookie className="h-6 w-6 text-cyan-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-slate-900 mb-2">Piškotki in zasebnost</h3>
              <p className="text-slate-600 mb-4 leading-relaxed">
                Ta spletna stran uporablja piškotke za izboljšanje uporabniške izkušnje. 
                Z uporabo te strani se strinjate z uporabo piškotkov v skladu z našo politiko zasebnosti.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button 
                  onClick={handleAccept}
                  className="bg-cyan-600 hover:bg-cyan-700 text-white transition-all duration-300"
                >
                  Sprejmi vse piškotke
                </Button>
                <Button 
                  onClick={handleReject}
                  variant="outline"
                  className="border-2 border-slate-300 text-slate-700 hover:border-slate-400 transition-all duration-300"
                >
                  Zavrni
                </Button>
              </div>
            </div>
            <button 
              onClick={handleClose}
              className="flex-shrink-0 p-2 hover:bg-slate-100 rounded-lg transition-colors"
              aria-label="Close"
            >
              <X className="h-5 w-5 text-slate-400" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
